<template>
  <div class="input_section">
    <div class="error_tips_container">
      <div v-if="hasEmptyCode" class="error_code_tip">
        <a-alert :show-icon="false" class="error_tips" message="請輸入驗證碼" banner />
        <a-icon type="warning" style="color: #FF6565" />
      </div>
      <div v-if="isErrorCode" class="error_code_tip">
        <a-alert :show-icon="false" class="error_tips" message="驗證碼錯誤，請再試一次" banner />
        <a-icon type="warning" style="color: #FF6565" />
      </div>
    </div>
    <div class="input_container">
      <input v-for="(item,index) in inputbox"
             :key="index"
             :ref="`ref${index}`"
             class="verification_input title_font_Weight"
             :class="emptyErrorStyle"
             v-model="item.value"
             type="number"
             @input="onInput(index,item)"
             @keyup.delete="onDelete(index)"
             @keydown="passCurrentCode(inputbox)"
             maxlength="1" />
    </div>
  </div>
</template>

<script>
import { bus } from '../../main';
  export default {
    name: 'ProvisioningVerificationCode',
    data () {
      return {
        inputbox: [
          {
            value: ''
          },
          {
            value: ''
          },
          {
            value: ''
          },
          {
            value: ''
          },
          {
            value: ''
          },
          {
            value: ''
          }
        ],
        hasEmptyCode: false,
        isErrorCode: false,
      }
    },
    created() {
        bus.$on("emptyCode", data => {
            this.hasEmptyCode = data;
        });
        bus.$on("errorCode", data => {
            this.isErrorCode = data;
        });          
    },    
    methods: {
      onInput (index) {
        // this.inputbox[index].value= item.value.replace(/[^\d]/g,'');
        if (this.inputbox[index].value.length !== 1) this.inputbox[index].value = this.inputbox[index].value.slice(0, -1);
        // 前五格輸入框，輸入數字後會自動將焦點移到下一格
        if (this.inputbox[index].value && index < 5) {
          this.$refs['ref' + (index + 1)][0].focus();
        }
        this.passCurrentCode(this.inputbox);
      },
      onDelete (index) {
        // 如果是第1格，不再退回到前一格輸入框
        if (index > 0) {
          this.$refs['ref' + (index - 1)][0].focus();
        }
      },
      passCurrentCode(payload) {
        bus.$emit('passCurrentCode', payload);
      }
    },
    computed: {
        emptyErrorStyle() {
            const inputErrorStyle = this.hasEmptyCode ? 'empty_error_tips' : '';
            return inputErrorStyle;
        },
    },    
  }
</script>

<style lang="scss" scoped>
    .input_section {
        overflow: hidden;
        .input_container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 18px;
            .verification_input {
              width: 14%;
              height: 40px;
              font-size: 27px;
              line-height: 40px;
              color: #343741;
              text-align: center;
              border-top: 0px;
              border-left: 0px;
              border-right: 0px;
              border-bottom-width: 1px;
              outline: none;
              border-bottom-style: solid;
              border-radius: 0;
            }
            .empty_error_tips.verification_input {
              border-bottom-color: #F10000;
            }
        }
    }

    .error_tips_container {
      overflow: hidden;
      .error_code_tip {
        position: relative;
        i {
          position: absolute;
          top: 50%;
          left: 1rem;
          transform: translateY(-50%);
        }
      }
      .error_tips {
        margin: 11px auto 15px auto;
        padding: 12px 16px;
        background-color: #FFF4F4;
      }
    }
</style>